export const sanitizePhoneInput = (value) => {
  if (!value) return '';

  const trimmed = value.trimStart();
  const hasLeadingPlus = trimmed.startsWith('+');
  const cleaned = trimmed.replace(/[^\d+\s\-()]/g, '');

  if (hasLeadingPlus) {
    return `+${cleaned.replace(/\+/g, '')}`;
  }

  return cleaned.replace(/\+/g, '');
};
